import React, { useState,useEffect  } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { KECAMATAN, getDesaByKecamatan } from "./datarecap/constants";
import './UpdateUserModal.css'

const ADMIN_ROLES = [
  { value: "admin", label: "Admin" },
  { value: "surveyor", label: "Surveyor" },
  { value: "verifikator", label: "Verifikator" },
  { value: "inputdata", label: "Input Data" },
  { value: "kepaladinas", label: "Kepala Dinas" },
  { value: "ppk", label: "PPK" },
  { value: "AGR", label: "AGR" },
  { value: "TFL", label: "TFL" },
  { value: "Koordinator TFL", label: "Koordinator TFL" },
  { value: "Supplier Penyedia", label: "Supplier Penyedia" },
  { value: "penerimabantuan", label: "Penerima Bantuan" },
  { value: "Kadis", label: "Kadis" },
  { value: "Bupati", label: "Bupati" },
];

const TFL_ROLES = [
  { value: "AGR", label: "AGR" },
  { value: "TFL", label: "TFL" },
  { value: "Supplier Penyedia", label: "Supplier Penyedia" },
  { value: "penerimabantuan", label: "Penerima Bantuan" },
];

const UpdateUserModal = ({ isOpen, toggle, user, onUserUpdated }) => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [noWa, setNoWa] = useState("");
  const [kecamatan, setKecamatan] = useState("");
  const [kecamatanList, setKecamatanList] = useState([]);
  const [desaKelurahan, setDesaKelurahan] = useState("");
  const [nip, setNip] = useState("");
  const [password, setPassword] = useState("");

  const authUser = useSelector((s) => s.authAdmin?.user);
  const currentUserRole = authUser?.role || '';
  const isAdmin = currentUserRole === 'admin';
  const isTFL = currentUserRole === 'TFL';
  const roleOptions = isAdmin ? ADMIN_ROLES : isTFL ? TFL_ROLES : [];

  useEffect(() => {
    if (user) {
      setUsername(user.username || "");
      setEmail(user.email || "");
      setRole(user.role || "");
      setNoWa(user.NoWa || "");
      setKecamatan(user.kecamatan || "");
      let list = [];
      try { list = JSON.parse(user.kecamatanList || '[]'); } catch { list = []; }
      if (!Array.isArray(list)) list = [];
      if (user.kecamatan && !list.includes(user.kecamatan)) list.push(user.kecamatan);
      setKecamatanList(list);
      setDesaKelurahan(user.desaKelurahan || "");
      setNip(user.nip || "");
    }
  }, [user]);

  const isKoordTfl = role === 'Koordinator TFL';
  const isAgr = role === 'AGR';
  const isPpk = role === 'PPK';

  const toggleKecamatan = (k) => {
    setKecamatanList((p) =>
      p.includes(k) ? p.filter((x) => x !== k) : [...p, k]
    );
  };

  const handleUpdate = async () => {
    if (isKoordTfl && kecamatanList.length === 0) {
      Swal.fire("Gagal!", "Minimal 1 kecamatan wajib untuk Koordinator TFL", "error");
      return;
    }
    try {
      const payload = {
        username: username || user.username,
        email: email || user.email,
        role: role || user.role,
        NoWa: noWa || undefined,
        kecamatan: (isKoordTfl || isAgr) ? (kecamatan || undefined) : undefined,
        kecamatanList: isKoordTfl ? JSON.stringify(kecamatanList) : undefined,
        nip: isPpk ? (nip || undefined) : undefined,
        desaKelurahan: isAgr ? (desaKelurahan || "") : undefined,
        password: password || undefined,
      };

      await axios.put(`${process.env.REACT_APP_URL}/updateuser/${user.id}`, payload, {
        withCredentials: true,
      });

      Swal.fire("Berhasil!", "Data user berhasil diperbarui.", "success");
      toggle();
      onUserUpdated();
    } catch (error) {
      console.error("Error updating user:", error);
      Swal.fire("Gagal!", error.response?.data?.msg || "Terjadi kesalahan saat memperbarui user.", "error");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} modalClassName="custom-modal">
      <ModalHeader toggle={toggle}>Update User</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="username">Username</Label>
            <Input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Masukkan username"
            />
          </FormGroup>
          <FormGroup>
            <Label for="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Masukkan email"
            />
          </FormGroup>
          <FormGroup>
            <Label for="noWa">Nomor WhatsApp</Label>
            <Input
              id="noWa"
              type="text"
              value={noWa}
              onChange={(e) => setNoWa(e.target.value)}
              placeholder="Masukkan nomor WA"
            />
          </FormGroup>
          <FormGroup>
            <Label for="role">Role</Label>
            <Input
              id="role"
              type="select"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              {roleOptions.map((r) => (
                <option key={r.value} value={r.value}>{r.label}</option>
              ))}
            </Input>
            {isTFL && (
              <small className="text-muted">Sebagai TFL, Anda hanya dapat mengatur role AGR, TFL, Supplier, dan Penerima Bantuan.</small>
            )}
          </FormGroup>
          {isPpk && (
            <FormGroup>
              <Label for="nip">NIP</Label>
              <Input
                id="nip"
                type="text"
                value={nip}
                onChange={(e) => setNip(e.target.value)}
                placeholder="Masukkan NIP (khusus PPK)"
              />
              <small className="text-muted">NIP tampil pada format Laporan Penggunaan Dana (LPD).</small>
            </FormGroup>
          )}
          {isKoordTfl && (
            <FormGroup>
              <Label>Kecamatan Wilayah Pantau (bisa lebih dari 1, wajib)</Label>
              <div style={{ border: '1px solid #ced4da', borderRadius: 6, padding: '8px 10px', maxHeight: 180, overflowY: 'auto' }}>
                {KECAMATAN.map((k) => (
                  <div key={k} className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`kec_list_${k}`}
                      checked={kecamatanList.includes(k)}
                      onChange={() => toggleKecamatan(k)}
                    />
                    <label className="form-check-label" htmlFor={`kec_list_${k}`} style={{ fontSize: 14, cursor: 'pointer' }}>
                      {k}
                    </label>
                  </div>
                ))}
              </div>
              <small className="text-muted">Koordinator TFL memantau & memverifikasi bantuan di kecamatan-kecamatan ini.</small>
            </FormGroup>
          )}
          {isAgr && (
            <>
              <FormGroup>
                <Label for="kecamatanAgr">Kecamatan Wilayah AGR</Label>
                <Input
                  id="kecamatanAgr"
                  type="select"
                  value={kecamatan}
                  onChange={(e) => { setKecamatan(e.target.value); setDesaKelurahan(""); }}
                >
                  <option value="">(Pilih Kecamatan)</option>
                  {KECAMATAN.map((k) => (
                    <option key={k} value={k}>{k}</option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="desaKelurahanAgr">Desa/Kelurahan Wilayah AGR</Label>
                <Input
                  id="desaKelurahanAgr"
                  type="select"
                  value={desaKelurahan}
                  disabled={!kecamatan}
                  onChange={(e) => setDesaKelurahan(e.target.value)}
                >
                  <option value="">{kecamatan ? '(Pilih Desa/Kelurahan)' : 'Pilih kecamatan dulu'}</option>
                  {getDesaByKecamatan(kecamatan).map((d) => (
                    <option key={d} value={d}>{d}</option>
                  ))}
                </Input>
                <small className="text-muted">AGR (Peliuk) difilter per kecamatan & desa/kelurahan saat penunjukan bantuan.</small>
              </FormGroup>
            </>
          )}
          <FormGroup>
            <Label for="password">Password (Opsional)</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Masukkan password baru (jika ada)"
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleUpdate}>
          Simpan
        </Button>
        <Button color="secondary" onClick={toggle}>
          Batal
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateUserModal;
